import { ConfigurationFeatureFlag } from '@tink/config/src/tinkLinkConfig';
import { useSelector } from 'react-redux';
import { useProduct } from '../../../../components/ApplicationProviders/ProductProvider/ProductProvider';
import { ProductDimensionPay } from '../../../../models/product';
import { useConfiguration } from '../../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { haveFeatureFlag } from '../../../../models/configuration';
import { AppState } from '../../../../stores/redux-store';
import { PaymentProviderConditions } from '../../models/payments';

export const useSourceAccountProvidedSkipsAis = () => {
  const providerPaymentConditions = useSelector(
    (state: AppState) => state.selectedProvider.data.paymentConditions
  );
  const session = useSelector((state: AppState) => state.session.data);
  const { productDimension } = useProduct();
  const { data: configurationData } = useConfiguration();
  const isBulkPayment = productDimension === ProductDimensionPay.BULK;

  const sourceAccountNumber = session?.sourceAccountNumber;

  return Boolean(
    PaymentProviderConditions.isSourceAccountProvidedSkipsAis(providerPaymentConditions) &&
      sourceAccountNumber &&
      // temp feature flag for internal testing, remove when confirmed that logic works as intended
      haveFeatureFlag(
        configurationData,
        ConfigurationFeatureFlag.TEST_SKIPPING_AIS_CONFIGURATION_CHANGE
      ) &&
      !isBulkPayment
  );
};
